const getFeedGeotarget = (state) => {
  let localizedFlag = false;
  if (state && state.flags && state.flags.treatments && state.flags.treatments.sl_localized_feed) {
    localizedFlag = state.flags.treatments.sl_localized_feed === 'on';
  }

  let geotarget = 'US';
  if (state && state.flags && state.flags.identity && state.flags.identity.isoCountryCode) {
    const {
      flags: {
        identity: { isoCountryCode },
      },
    } = state;
    geotarget = isoCountryCode;
  }

  if (
    state &&
    state.user &&
    state.user.settings &&
    state.user.settings.feed &&
    state.user.settings.feed.localized &&
    localizedFlag
  ) {
    const {
      user: {
        settings: {
          feed: { localized },
        },
      },
    } = state;
    geotarget = localized !== 'LOCALIZED' ? localized : geotarget;
  }

  return geotarget;
};

export default getFeedGeotarget;
